import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "professionalDetailTab" }
const _hoisted_2 = { class: "wizard-action" }
const _hoisted_3 = { class: "d-flex ga-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_InfoBox = _resolveComponent("InfoBox")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_AutoCompleteField = _resolveComponent("AutoCompleteField")!
  const _component_ComboBoxField = _resolveComponent("ComboBoxField")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ExperienceDetailJobPreferences = _resolveComponent("ExperienceDetailJobPreferences")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_confirm_dialog = _resolveComponent("confirm-dialog")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_form, {
      ref: "frmMain",
      "lazy-validation": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "12",
              class: "text-center text-md-left"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("h1", null, "Job Preferences", -1)
              ])),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_InfoBox, { title: "Tell us about your Job Preferences, and your main Area of expertise. This will help us to match you with your perfect role, and help employers see if their project is the right fit for you." })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, { loading: _ctx.dataLoading }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("Your Main Expertise")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createElementVNode("span", { class: "f-body-1" }, "In which field do you have the most experience?", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "4",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteField, {
                                  readonly: _ctx.isHiringmanager,
                                  dense: "",
                                  placeholder: "Position",
                                  "item-title": "Name",
                                  "item-value": "id",
                                  rules: [_ctx.validations.required],
                                  items: _ctx.jobRoles,
                                  modelValue: _ctx.selectedJobRole,
                                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedJobRole) = $event)),
                                  outlined: ""
                                }, null, 8, ["readonly", "rules", "items", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "4",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ComboBoxField, {
                                  readonly: _ctx.isHiringmanager && !_ctx.selectedJobRole,
                                  id: "jobTitle",
                                  clearable: "",
                                  placeholder: "Title",
                                  items: _ctx.jobTitles,
                                  outlined: "",
                                  dense: "",
                                  "item-title": "Name",
                                  "item-value": "id",
                                  rules: [_ctx.validations.required],
                                  "closable-chips": "",
                                  "onUpdate:modelValue": [
                                    _ctx.getJobTitle,
                                    _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedJobTitle) = $event))
                                  ],
                                  modelValue: _ctx.selectedJobTitle
                                }, null, 8, ["readonly", "items", "rules", "onUpdate:modelValue", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                _createElementVNode("span", { class: "f-body-1" }, "How Many years of Experience do you have in this field?", -1)
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_col, {
                              md: "4",
                              cols: "12"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteField, {
                                  readonly: _ctx.isHiringmanager,
                                  dense: "",
                                  outlined: "",
                                  hint: "Determine the amount of your total experience",
                                  items: _ctx.experienceYears,
                                  rules: [_ctx.validations.required, _ctx.validations.ValidItem(_ctx.experienceYears)],
                                  placeholder: "Total years of experience",
                                  modelValue: _ctx.selectedExperienceYear,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedExperienceYear) = $event))
                                }, null, 8, ["readonly", "items", "rules", "modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_ExperienceDetailJobPreferences, {
                  isHiringmanager: _ctx.isHiringmanager,
                  jobTitles: _ctx.details.filter((item) => item.Type == 'JobTitle'),
                  jobPreferencesList: _ctx.teamMember?.JobPreferences,
                  onSaveJobPreferences: _ctx.SaveJobPreferences,
                  onRemoveJobPreferences: _ctx.removeJobPreferences,
                  loading: _ctx.submitting,
                  showRequired: true
                }, null, 8, ["isHiringmanager", "jobTitles", "jobPreferencesList", "onSaveJobPreferences", "onRemoveJobPreferences", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.isAfterSignUp)
          ? (_openBlock(), _createBlock(_component_v_card_actions, { key: 0 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_tooltip, {
                    top: "",
                    attach: ""
                  }, {
                    activator: _withCtx(({ props }) => [
                      (!_ctx.isHiringmanager)
                        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
                            key: 0,
                            class: "secondary_btn"
                          }, props, {
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getAllDataAndSubmit(true))),
                            disabled: _ctx.submitting,
                            loading: _ctx.submitting,
                            "prepend-icon": "mdi-check"
                          }), {
                            default: _withCtx(() => _cache[13] || (_cache[13] = [
                              _createTextVNode("Save and exit")
                            ])),
                            _: 2
                          }, 1040, ["disabled", "loading"]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "You can save your progress and return to the application process later", -1))
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_3, [
                    (!_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "primary_btn",
                          onClick: _ctx.goBack,
                          disabled: _ctx.submitting,
                          loading: _ctx.submitting,
                          "prepend-icon": "mdi-chevron-left"
                        }, {
                          default: _withCtx(() => _cache[15] || (_cache[15] = [
                            _createTextVNode("Back")
                          ])),
                          _: 1
                        }, 8, ["onClick", "disabled", "loading"]))
                      : _createCommentVNode("", true),
                    (!_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 1,
                          class: "primary_btn",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getAllDataAndSubmit(false))),
                          disabled: _ctx.submitting,
                          loading: _ctx.submitting,
                          "append-icon": "mdi-chevron-right"
                        }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("Next ")
                          ])),
                          _: 1
                        }, 8, ["disabled", "loading"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card_actions, {
              key: 1,
              class: "mt-5"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  md: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isHiringmanager)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          class: "primary_btn actionButton",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm())),
                          disabled: _ctx.submitting,
                          loading: _ctx.submitting,
                          "prepend-icon": "mdi-check"
                        }, {
                          default: _withCtx(() => _cache[17] || (_cache[17] = [
                            _createTextVNode("Save")
                          ])),
                          _: 1
                        }, 8, ["disabled", "loading"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 1
    }, 512),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showSaveForLaterConfirm,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.showSaveForLaterConfirm) = $event)),
      "max-width": "500",
      onKeydown: _cache[8] || (_cache[8] = _withKeys(($event: any) => (_ctx.showSaveForLaterConfirm = false), ["esc"]))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_confirm_dialog, {
          loading: _ctx.savingLoading,
          message: _ctx.confirmModel,
          onConfirm: _cache[6] || (_cache[6] = ($event: any) => (_ctx.save(true, true))),
          onCancel: _ctx.cancelSaving
        }, null, 8, ["loading", "message", "onCancel"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}